import { useQuery } from '@tanstack/react-query';
import { GetRecommendedArticleParams } from '@src/api/articles.ts';
import { API } from '@src/api/index.ts';

export const useRecommendedArticleQuery = (params: GetRecommendedArticleParams) => {
  return useQuery({
    queryKey: ['recommendedArticle', params],
    queryFn: async () => await API.articles.getRecommended(params),
    enabled: typeof params.hash !== 'undefined',
  });
};
